import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { transfers, siteInfo } from '../data/mock';
import { Button } from './ui/button';
import { Clock, MapPin, ArrowRight } from 'lucide-react';

const TransfersSection = () => {
  const { language, t } = useLanguage();

  return (
    <section id="transfers" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-teal-600 font-medium text-sm uppercase tracking-wider">
            {language === 'en' ? 'Airport Transfers' : 'Transferts Aéroport'}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mt-3 mb-4">
            {t.services.transfers.title}
          </h2>
          <p className="text-stone-600 max-w-2xl mx-auto text-lg">
            {t.services.transfers.description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {transfers.map((transfer) => (
            <div
              key={transfer.id}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 border border-stone-100 group"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 rounded-lg bg-teal-50 text-teal-600 flex items-center justify-center">
                  <MapPin className="w-6 h-6" />
                </div>
                <div className="text-right">
                  <span className="text-2xl font-bold text-stone-800">${transfer.price}</span>
                  <p className="text-xs text-stone-500">{language === 'en' ? 'per car' : 'par voiture'}</p>
                </div>
              </div>

              <h3 className="text-lg font-semibold text-stone-800 mb-2 group-hover:text-teal-600 transition-colors">
                {transfer[language].name}
              </h3>

              <p className="text-stone-600 text-sm mb-4">
                {transfer[language].description}
              </p>

              <div className="flex items-center gap-2 text-stone-500 text-sm mb-5">
                <Clock className="w-4 h-4" />
                <span>{transfer.duration}</span>
              </div>

              <a
                href={`${siteInfo.whatsappLink}?text=${encodeURIComponent(
                  language === 'en'
                    ? `Hi, I'd like to book a transfer: ${transfer.en.name}`
                    : `Bonjour, je voudrais réserver un transfert: ${transfer.fr.name}`
                )}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="outline" className="w-full border-stone-200 hover:bg-teal-600 hover:text-white hover:border-teal-600 transition-colors">
                  {t.tours.bookNow}
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </a>
            </div>
          ))}
        </div>

        {/* Driver Options */}
        <div className="mt-16 bg-white rounded-2xl p-8 shadow-sm border border-stone-100">
          <h3 className="text-2xl font-bold text-stone-800 mb-6 text-center">
            {t.drivers.title}
          </h3>
          <p className="text-stone-600 text-center mb-8">
            {t.drivers.subtitle}
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { icon: '🇬🇧', label: t.drivers.english },
              { icon: '🇫🇷', label: t.drivers.french },
              { icon: '🇬🇧👤', label: t.drivers.englishGuide },
              { icon: '🇫🇷👤', label: t.drivers.frenchGuide },
            ].map((option, idx) => (
              <div
                key={idx}
                className="flex items-center gap-3 p-4 rounded-xl bg-stone-50 hover:bg-teal-50 transition-colors cursor-pointer"
              >
                <span className="text-2xl">{option.icon}</span>
                <span className="text-stone-700 font-medium text-sm">{option.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransfersSection;